import { Serializable } from '../../../core/models/serializable';
import { PromoEmailAttachmentModel } from './promo-email-attachment-model';

export class TemplateEditSubmitDataModel
  implements Serializable<TemplateEditSubmitDataModel>
{
  fromObject(object: any): TemplateEditSubmitDataModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    return {
      PromoEmailTemplateId: this.promoEmailTemplateId,
      Name: this.name,
      Subject: this.subject,
      Content: this.content,
      ValidFrom: this.validFrom,
      ValidTo: this.validTo,
      Attachments: this.attachments.map((a) => a.toObject()),
      Portfolios: this.portfolios,
    };
  }

  public promoEmailTemplateId: number;
  public name: string;
  public subject: string;
  public content: string;
  public validFrom: Date;
  public validTo: Date;
  public attachments: PromoEmailAttachmentModel[];
  public portfolios: number[];

  constructor() {
    this.attachments = [];
    this.portfolios = [];
  }
}
